import React, { HTMLAttributes } from 'react'
import classnames from 'classnames'
import styles from './styles.css'

export interface BottomAppBarItemProps extends HTMLAttributes<HTMLDivElement> {
  grow?: 1 | 2 | 3 | 4
}

const BottomAppBarItem: React.SFC<BottomAppBarItemProps> = ({
  grow = 1,
  className,
  style = {},
  ...rest
}) => {
  return (
    <div
      className={classnames(styles.item, className)}
      style={{ flexGrow: grow, ...style }}
      {...rest}
    />
  )
}

export default BottomAppBarItem
